import React, { useState } from 'react';

interface SearchInputProps {
    placeholder?: string;
    onSearch: (value: string) => void;
    value?: string | undefined;
    disabled?: boolean;
    className?: string;
    searchIconClass?: string;
}

const SearchInput = ({
    placeholder = '검색어를 입력해주세요.',
    onSearch,
    value = '',
    disabled = false,
    className = '',
    searchIconClass = 'ti ti-search',
}: SearchInputProps) => {
    const [internalValue, setInternalValue] = useState(value);
    const handleSearch = () => {
        if (onSearch) {
            onSearch(internalValue);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setInternalValue(newValue);
    };

    return (
        <div className={`input-group ${className}`}>
            <input
                type="text"
                className="form-control"
                placeholder={placeholder}
                onChange={handleInputChange}
                onKeyDown={handleKeyPress}
                disabled={disabled}
                value={internalValue}
                aria-label="Search input"
                aria-describedby="search-button"
            />
            <button
                type="button"
                className="btn btn-primary"
                onClick={handleSearch}
                disabled={disabled}
                id="search-button"
            >
                <i className={searchIconClass}></i>
            </button>
        </div>
    );
};

export default SearchInput;
